import { headerButtonMobile } from "features/orders/index.styles";

export const dropdownWidth = { width: { xs: "100%", md: "auto" } };

export const bulkActionsStyle = {
  ...headerButtonMobile,
  marginTop: { xs: "12px", md: "0px" },
};
